import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import BrandLogo from '../BrandLogo'
import SocialLinks from '../Common/SocialLinks'
import { api, getListItems } from '../../services/api'
import { getImageUrl } from '../../utils/imageUrl'

function SideMenu({ isOpen, onClose }) {
    const [settings, setSettings] = useState({})
    const [recentPosts, setRecentPosts] = useState([])

    useEffect(() => {
        let cancelled = false
        Promise.all([
            api.getSettings().catch(() => null),
            api.getBlogPosts({ per_page: 3 }).catch(() => null),
        ]).then(([settingsRes, blogRes]) => {
            if (cancelled) return
            setSettings(settingsRes?.data || {})
            setRecentPosts(getListItems(blogRes).slice(0, 3))
        })
        return () => { cancelled = true }
    }, [])

    const aboutText = (settings.footer_about_text || '').trim()
        || 'Explore destinations, guided tours, and memorable adventures with Travel With Ammar.'
    const phones = [settings.footer_phone_1, settings.footer_phone_2]
        .map((v) => (v || '').trim())
        .filter(Boolean)
    const emails = [settings.footer_email_1, settings.footer_email_2]
        .map((v) => (v || '').trim())
        .filter(Boolean)
    const address = (settings.footer_address || '').trim()

    return (
        <div
            className={`sidemenu-wrapper sidemenu-info ${isOpen ? 'show' : ''}`}
            style={{ visibility: isOpen ? 'visible' : 'hidden' }}
            onClick={onClose}
            aria-label="Close"
        >
            <div className="sidemenu-content" onClick={(e) => e.stopPropagation()}>
                <button className="closeButton sideMenuCls" onClick={onClose} aria-label="Close">
                    <i className="far fa-times" />
                </button>
                <div className="widget">
                    <div className="th-widget-about">
                        <div className="about-logo">
                            <BrandLogo />
                        </div>
                        <p className="about-text">{aboutText}</p>
                        <div className="th-social">
                            <SocialLinks className="" />
                        </div>
                    </div>
                </div>
                {recentPosts.length > 0 && (
                    <div className="widget">
                        <h3 className="widget_title">Recent Posts</h3>
                        <div className="recent-post-wrap">
                            {recentPosts.map((post) => (
                                <div className="recent-post" key={post.id}>
                                    <div className="media-img">
                                        <Link to={`/blog/${post.id}`} onClick={onClose}>
                                            <img
                                                src={getImageUrl(post.image, 'blog')}
                                                alt={post.title || 'Blog'}
                                            />
                                        </Link>
                                    </div>
                                    <div className="media-body">
                                        {post.published_at && (
                                            <div className="recent-post-meta">
                                                <Link to="/blog" onClick={onClose}>
                                                    <i className="far fa-calendar" />
                                                    {new Date(post.published_at).toLocaleDateString()}
                                                </Link>
                                            </div>
                                        )}
                                        <h4 className="post-title">
                                            <Link className="text-inherit" to={`/blog/${post.id}`} onClick={onClose}>
                                                {post.title}
                                            </Link>
                                        </h4>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {(phones.length > 0 || emails.length > 0 || address) && (
                    <div className="widget">
                        <h3 className="widget_title">Get In Touch</h3>
                        <div className="th-widget-contact">
                            {phones.length > 0 && (
                                <div className="info-box_text">
                                    <div className="icon">
                                        <img src="/assets/img/icon/phone.svg" alt="" />
                                    </div>
                                    <div className="details">
                                        {phones.map((phone) => (
                                            <p key={phone}>
                                                <a href={`tel:${phone.replace(/\s+/g, '')}`} className="info-box_link">
                                                    {phone}
                                                </a>
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {emails.length > 0 && (
                                <div className="info-box_text">
                                    <div className="icon">
                                        <img src="/assets/img/icon/envelope.svg" alt="" />
                                    </div>
                                    <div className="details">
                                        {emails.map((mail) => (
                                            <p key={mail}>
                                                <a href={`mailto:${mail}`} className="info-box_link">
                                                    {mail}
                                                </a>
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {address && (
                                <div className="info-box_text">
                                    <div className="icon">
                                        <img src="/assets/img/icon/location-dot.svg" alt="" />
                                    </div>
                                    <div className="details">
                                        <p>{address}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SideMenu
